/**
 * Libraries
 */

import { InMemoryCache } from '@apollo/client/core';

/**
 * Apollo cache
 */

import { typePolicies } from '@core/apollo/cache/typePolicies';

const cache = new InMemoryCache({
  typePolicies,
});

export { cache };
